<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded" role="doc-dedication">
<p class="dedf"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>For Dave, whose passion for family and weather knows few bounds, for bringing so much joy, laughter, and love into my life</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-prager-0005.vue?e36765e2